import { FormItemType } from '../constants/form-builder.constants'
import { FormBuilderConfig } from '../types/form-builder.types'

export const createBuilderValues = (config: FormBuilderConfig[], values?: Record<string, any>): Record<string, any> => {
  return [...config]
    .filter((configItem) => configItem.type != FormItemType.Header)
    .reduce((acc: Record<string, any>, configItem) => {
      acc[configItem.id] = values?.[configItem.id] ?? ''

      return acc
    }, {})
}
